















import { Ingredient } from '@/types/Ingredient.d.ts';
import IngredientVue from '@/components/Ingredient.vue';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  components: {
    IngredientVue,
  },
  props: {
    targetIngredients: {
      type: Array as PropType<Ingredient[]>,
    },
  },
  data() {
    return {
      count: 5,
    };
  },
  computed: {
    listItems(): Ingredient[] {
      const list = this.targetIngredients;
      return list.slice(0, this.count);
    },
  },
  methods: {
    isMore() {
      this.count = this.targetIngredients.length;
    },
    isLess() {
      this.count = 5;
    },
  },
});
